import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { UiInfiniteScrollDirective } from '../../../directives';
import { BOARD_COLUMN_COLORS_MAP, IconsInitConfigType } from '../../../constants';
import { BoardColumnColorType } from '../../../types';
import { IconUIComponent } from '../icon/icon.component';

import { ContentBorderShadowUIComponent } from '../content-border-shadow/content-border-shadow.component';

const DEFAULT_BOARD_COLUMN_MIN_WIDTH_PX = 400;
@Component({
  selector: 'fr8bot-ui-board-column',
  host: {
    '[style.--board-column-min-width.px]': 'minWidth',
  },
  standalone: true,
  templateUrl: './board-column.component.html',
  styleUrl: './board-column.component.scss',
  imports: [
    NgClass,
    TranslatePipe,
    UiInfiniteScrollDirective,
    IconUIComponent,
    ContentBorderShadowUIComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardColumnUIComponent {
  readonly minWidthPx = input(DEFAULT_BOARD_COLUMN_MIN_WIDTH_PX);

  get minWidth() {
    return this.minWidthPx();
  }

  readonly color = input<BoardColumnColorType>('green');
  readonly iconName = input<IconsInitConfigType | undefined>(undefined);
  readonly titleText = input<string>('');
  readonly subtitleText = input<string>('');
  readonly itemsCount = input<number>(0);
  /** On while a page loads or the last one is reached; scrolling to the end requests no more. */
  readonly loadMoreDisabled = input(false);

  readonly scrolledToBottom = output<void>();

  readonly COLORS_MAP = BOARD_COLUMN_COLORS_MAP;
}
